import React from 'react'
import SvgIcon from 'components/SvgIcon'

const IconData = props => (
  <SvgIcon x="0px" y="0px" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="M 2,30c0,1.104, 0.896,2, 2,2l 24,0 c 1.104,0, 2-0.896, 2-2L 30,2 c0-1.104-0.896-2-2-2L 4,0 C 2.896,0, 2,0.896, 2,2L 2,30 z M 4,2 l 24,0 l0,28 L 4,30 L 4,2 zM 8,18L 12,18L 12,26L 8,26zM 14,8L 18,8L 18,26L 14,26zM 20,12L 24,12L 24,26L 20,26z"
    />
  </SvgIcon>
)

export default IconData
